const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/employees.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/supervisor/employees")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/* ─── Employee Card ─── */

/* ─── Invite Dialog ─── */